import { render, staticRenderFns } from "./CardChart.vue?vue&type=template&id=37993389&scoped=true&"
import script from "./CardChart.vue?vue&type=script&lang=js&"
export * from "./CardChart.vue?vue&type=script&lang=js&"
import style0 from "./CardChart.vue?vue&type=style&index=0&id=37993389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37993389",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {VCard,VDialog})
